module.exports = "<h3>Admin</h3>\r\n<ul class=\"nav nav-pills\">\r\n\t<li class=\"nav-item\" *ngFor=\"let route of routeInfo\"><a class=\"nav-link\" routerLinkActive=\"active\" routerLink=\"{{route.path}}\">{{route.name}}</a></li>\r\n</ul>\r\n<router-outlet></router-outlet>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/admin.component.html
// module id = ./src/app/admin/admin.component.html
// module chunks = 0